import axios from "axios";

import { Notification, Message, MessageBox } from "element-react";
import "element-theme-default";

const percentile = require("percentile");
const validator = require("validator");

class Common {
  $(obj) {
    let attr = obj.substring(0, 1);
    let ci = obj.substring(1);
    if (attr === "#") {
      return document.getElementById(ci).value;
    } else if (attr === ".") {
      return document.getElementsByClassName(ci).value;
    }
  }

  maxZero(num) {
    const number = Number(num);
    return Math.max(number || 0, 0);
  }

  getCoordinate(origX, origY, distance) {
    let x = Math.cos(this.calcAngleDegrees(origX, origY)) * distance;
    let y = Math.sin(this.calcAngleDegrees(origX, origY)) * distance;
    return `(${origX + x}, ${origY + y})`;
  }

  calcAngleDegrees(x, y) {
    return (Math.atan2(y, x) * 180) / Math.PI;
  }

  calcDegressToRadian(r) {
    return parseFloat(r) * (Math.PI / 180);
  }

  lineAlignment(text) {
    if (typeof text != "undefined" && text !== null) {
      return text.replace(new RegExp("\n", "g"), "<br/>");
    }
    return text;
  }

  checkIsEmptyObject(obj) {
    if (obj === undefined) {
      return true;
    } else {
      return obj === null || Object.keys(obj).length === 0;
    }
  }

  nvl(str, replaceStr) {
    if (this.isNull(str) || this.isUndefined(str)) {
      return replaceStr;
    }
    return str;
  }

  isNull(str) {
    const chkStr = str + "";
    if (chkStr === "" || chkStr === null || chkStr.toLowerCase() === "null") {
      return true;
    }
    return false;
  }

  isUndefined(str) {
    if (
      typeof str === undefined ||
      typeof str === "undefined" ||
      str === "undefined" ||
      str === undefined
    ) {
      return true;
    }
    return false;
  }

  checkIsNull(str) {
    if (
      str == "" ||
      str == null ||
      str == undefined ||
      (str != null && typeof str == "object" && !Object.keys(str).length)
    ) {
      return true;
    } else {
      return false;
    }
  }

  cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  getNumbers(num, cnt, ordr) {
    let result = [];
    if (ordr === "desc") {
      let stand = parseInt(num);
      for (let i = 0; i < cnt; i++) {
        result.push({
          text: stand - i,
          value: stand - i,
        });
      }
    } else {
      let stand = parseInt(num) - cnt + 1;
      for (let i = 0; i < cnt; i++) {
        result.push({
          text: stand + i,
          value: stand + i,
        });
      }
    }
    return result;
  }

  renameKey(obj, oldKey, newKey) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
    return obj;
  }

  renameKeyOfJson(json, oldKey, newKey) {
    const arr = JSON.parse(json);
    arr.forEach((obj) => this.renameKey(obj, oldKey, newKey));
    return JSON.stringify(arr);
  }

  fillZero(width, str) {
    return str.length >= width
      ? str
      : new Array(width - str.length + 1).join("0") + str;
  }

  setComma(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getKeyValues(data, key) {
    let result = [];
    data.some((v) => {
      result.push(v[key]);
    });
    return result;
  }

  calcArraySum(arr) {
    return arr.reduce((a, b) => a + b);
  }

  calcArrayAvg(arr) {
    return this.calcArraySum(arr) / arr.length;
  }

  calcPercentile(n, arr) {
    return percentile(n, arr);
  }

  sortDesc(arr) {
    return arr.sort().reverse();
  }

  sortAsc(arr) {
    return arr.sort();
  }

  calcSplitArrayAvg(arr, start, end) {
    const splitArr = arr.slice(start, end);
    return this.calcArrayAvg(splitArr);
  }

  // key를 이용한 객체의 합 구하기
  // ex) sumValuesAtPath(data, 'device.pwConsumtion') => data.device.pwConsumtion의 값들을 모두 합한 값을 반환
  // 없거나 잘못된 값은 0으로 처리
  sumValuesAtPath(data, key) {
    if (!Array.isArray(data) || data.length === 0 || typeof key !== 'string') {
      return 0; // 잘못된 입력 처리
    }

    const keys = key.split('.');

    return data.reduce((acc, cur) => {
      let value = cur;
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          value = 0;  // 중간에 키가 없거나 잘못된 값이면 0 처리
          break;
        }
      }
      value = Number(value);
      return acc + (typeof value === 'number' ? value : 0);
    }, 0);
  }

  /* 이전 작업 내용 - 시작 - 2024.04 */
  // getAddressInfo(address) {
  //     return new Promise(function (resolve) {
  //         axios.get(`${process.env.REACT_APP_OPENAPI_URL}/open-api/search-address/${address}`)
  //         .then(res => {
  //             resolve(res.data);
  //         }).catch(error => {
  //             console.log(error);
  //             resolve(false);
  //         });
  //     });
  // }
  /* 이전 작업 내용 - 끝 - 2024.04 */

  /**
   * 주소정보
   * @param {*} address
   */
  getAddressInfo(address) {}

  /**
   * 코드정보
   * @param {*} groupCode
   */
  getCodeInfo(groupCode) {
    return new Promise(function (resolve) {
      axios
        .get(`/api/code/${groupCode}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          console.log(error);
          resolve(false);
        });
    });
  }

  fileDown(fileId) {
    console.log("fileId: ", fileId);
    if (fileId === null) {
      this.notification("warning", "파일이 존재하지 않습니다.");
      return;
    }
    window.open(process.env.REACT_APP_BASE_URL + "/api/file/" + fileId);
  }

  notification(type, message) {
    switch (type) {
      case "success":
        Notification({
          title: "성공",
          message: message,
          type: "success",
        });
        break;

      case "modify":
        Notification({
          title: "성공",
          message: message,
          type: "success",
        });
        break;
      case "warning":
        Notification({
          title: "알림",
          message: message,
          type: "warning",
          duration: 3000,
        });
        break;
      case "info":
        Notification.info({
          title: "알림",
          message: message,
          duration: 3000,
        });
        break;
      case "error":
        Notification.error({
          title: "경고",
          message: message,
          duration: 5000,
        });
        break;
    }
  }

  error(error) {
    let msg = "";
    let data = error.response.data;
    let errorInfos = {
      errorCode: data.code,
      status: data.status,
      errors: data.message,
    };
    console.log(errorInfos.errors);
    //this.notification("error", errorInfos.errors);
    return false;
  }

  create(url, param) {
    if (process.env.NODE_ENV === "development")
      console.log("파라미터: ", param);

    let result = {
      isSuccess: false,
      res: null,
    };
    return new Promise(function (resolve) {
      MessageBox.confirm("저장 하시겠습니까?", "Confirm", {
        confirmButtonText: "예",
        cancelButtonText: "아니오",
        type: "info",
      })
        .then(() => {
          axios
            .post(url, param)
            .then((response) => {
              Message({
                type: "success",
                message: "성공적으로 저장되었습니다.",
                iconClass: "success",
              });
              result.isSuccess = true;
              result.res = response;
              resolve(result);
            })
            .catch((error) => {
              Message({
                type: "error",
                message: error.response.data.message,
              });
              resolve(result);
            });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "작업이 취소되었습니다.",
            iconClass: "cancel",
          });
          resolve(result);
        });
    });
  }

  update(url, param) {
    if (process.env.NODE_ENV === "development")
      console.log("파라미터: ", param);

    let result = {
      isSuccess: false,
      res: null,
    };
    return new Promise(function (resolve) {
      MessageBox.confirm("수정하시겠습니까?", "Confirm", {
        confirmButtonText: "예",
        cancelButtonText: "아니오",
        type: "info",
      })
        .then(() => {
          axios
            .patch(url, param)
            .then((response) => {
              Message({
                type: "success",
                message: "성공적으로 수정되었습니다.!",
                duration: 3000,
                iconClass: "success",
              });
              result.isSuccess = true;
              result.res = response;
              resolve(result);
            })
            .catch((error) => {
              Message({
                type: "error",
                message: error.response.data.message,
              });

              resolve(result);
            });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "작업이 취소되었습니다.",
            iconClass: "cancel",
          });
          resolve(result);
        });
    });
  }

  delete(url) {
    let result = {
      isSuccess: false,
      res: null,
    };
    return new Promise(function (resolve) {
      MessageBox.confirm("삭제 하시겠습니까?", "Confirm", {
        confirmButtonText: "예",
        cancelButtonText: "아니오",
        type: "info",
      })
        .then(() => {
          axios
            .delete(url, {})
            .then((response) => {
              Message({
                type: "success",
                message: "성공적으로 삭제되었습니다.!",
                iconClass: "success",
                duration: 3000,
              });
              result.isSuccess = true;
              result.res = response;
              resolve(result);
            })
            .catch((error) => {
              Message({
                type: "error",
                iconClass: "cancel",
                message: error.response.data.message,
              });
              resolve(result);
            });
        })
        .catch(() => {
          Message({
            type: "info",
          iconClass: "cancel",
            message: "작업이 취소되었습니다.",
          });
          resolve(result);
        });
    });
  }

  customCreate(url, param, msg) {
    if (process.env.NODE_ENV === "development")
      console.log("파라미터: ", param);

    let result = {
      isSuccess: false,
      res: null,
    };
    return new Promise(function (resolve) {
      MessageBox.confirm(msg, "Confirm", {
        confirmButtonText: "예",
        cancelButtonText: "아니오",
        type: "info",
      })
        .then(() => {
          axios
            .post(url, param)
            .then((response) => {
              Message({
                type: "success",
                message: "처리되었습니다.",
              });
              result.isSuccess = true;
              result.res = response;
              resolve(result);
            })
            .catch((error) => {
              Message({
                type: "error",
                message: error.response.data.message,
              });
              resolve(result);
            });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "작업이 취소되었습니다.",
          });
          resolve(result);
        });
    });
  }
  customUpdate(params) {
    const { url, param, confirmMsg, successMsg, cancelMsg } = params;

    let result = {
      isSuccess: false,
      res: null,
    };

    return new Promise(function (resolve) {
      MessageBox.confirm(confirmMsg, "Confirm", {
        confirmButtonText: "예",
        cancelButtonText: "아니오",
        type: "info",
      })
        .then(() => {
          axios
            .patch(url, param)
            .then((response) => {
              Message({
                type: "success",
                message: successMsg || "처리되었습니다.",
                iconClass: "success",
              });
              result.isSuccess = true;
              result.res = response;
              resolve(result);
            })
            .catch((error) => {
              Message({
                type: "error",
                message: error.response.data.message,
                iconClass: "error",
              });
              resolve(result);
            });
        })
        .catch(() => {
          Message({
            type: "info",
            message: cancelMsg || "작업이 취소되었습니다.",
            iconClass: "cancel",
          });
          resolve(result);
        });
    });
  }

  formatDecimalInArray(list, keyOrPrecision, maybePrecision) {
      // 예외 1: 배열 아님
    if (!Array.isArray(list)) {
      console.warn("입력값이 배열이 아닙니다.");
      return [];
    }

    // 숫자 배열 처리
    if (typeof keyOrPrecision === "number") {
      const precision = keyOrPrecision;

      if (!Number.isInteger(precision) || precision < 0) {
        console.warn("precision은 0 이상의 정수여야 합니다.");
        return [...list]; // 원본 복사 반환
      }

      return list.map((item) =>
        typeof item === "number"
          ? Number(item.toFixed(precision))
          : item // 숫자가 아니면 그대로 반환
      );
    }

    // 객체 배열 처리
    if (
      typeof keyOrPrecision === "string" &&
      typeof maybePrecision === "number"
    ) {
      const key = keyOrPrecision;
      const precision = maybePrecision;

      if (!Number.isInteger(precision) || precision < 0) {
        console.warn("precision은 0 이상의 정수여야 합니다.");
        return [...list];
      }

      return list.map((item) => {
        if (item && typeof item === "object" && typeof item[key] === "number") {
          return {
            ...item,
            [key]: Number(item[key].toFixed(precision)),
          };
        }
        return item;
      });
    }

    // 그 외 잘못된 인자 조합
    console.warn("인자 타입이 올바르지 않습니다. 사용법을 확인하세요.");
    return [...list];
  }

}

export default new Common();
